import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { routeConfiguration } from '../../../../index';
import { createResourceLocatorString } from '../../../../util/routes';
import RegionCard from '../../../BasicUI/Cards/RegionCard';
import { withBaseComponent } from '../../hoc/withBaseComponent';

const destinations = [
  {
    title: 'NRW',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/2560x1794/49afe77dee/nrw.webp',
      alt: 'Splash of Germany Bayern Castle',
      title: 'Splash of Germany Bayern Castle',
    },
    slug: 'zeltplatz',
    rest: 'nrw',
  },
  {
    title: 'Bayern',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/c0f7caec8e/bayern.webp',
      alt: 'Lavendel Wiesen in Frankreich',
      title: 'Lavendel Wiesen in Frankreich',
    },
    slug: 'zeltplatz',
    rest: 'bayern',
  },
  {
    title: 'Niedersachsen',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/340065c7ca/niedersachsen.webp',
      alt: 'Italy Coast',
      title: 'Italy Coast',
    },
    slug: 'zeltplatz',
    rest: 'niedersachsen',
  },
  {
    title: 'Sachsen',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x347/1ff926721e/sachsen.webp',
      alt: 'Mountains of swiss',
      title: 'Mountains of swiss',
    },
    slug: 'zeltplatz',
    rest: 'sachsen',
  },
  {
    title: 'Schleswig-Holstein',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x427/c4e8aedbbf/schleswig.webp',
      alt: 'Austra view of mountains',
      title: 'Austra view of mountains',
    },
    slug: 'zeltplatz',
    rest: 'schleswig-holstein',
  },
  {
    title: 'Hessen',
    subtitle: 'Zeltplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/444x250/72bae63cda/dsc_6499-scaled-p96weu984j2k093e731lnhj453jl4zumo0k15g6k8w.jpeg',
      alt: 'Coast of Spain',
      title: 'Coast of Spain',
    },
    slug: 'zeltplatz',
    rest: 'hessen',
  },
  {
    title: 'Bodensee',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/2000x1333/dfd7142031/bodensee.webp',
      alt: 'Bodensee mit Booten auf dem See und einer Stadt im Vordergrund',
      title: 'Bodensee mit Booten auf dem See und einer Stadt im Vordergrund',
    },
    slug: 'zeltplatz',
    rest: 'bodensee',
  },
  {
    title: 'Chiemsee',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x360/06c873b1a1/chiemsee.webp',
      alt: 'Segelboote und ein weiteres Schiff fahren auf dem Chiemsee',
      title: 'Segelboote und ein weiteres Schiff fahren auf dem Chiemsee',
    },
    slug: 'zeltplatz',
    rest: 'chiemsee',
  },
  {
    title: 'Bremen',
    subtitle: 'Zeltplätze',
    image: {
      filename:
        'https://a.storyblok.com/f/267180/640x467/25bca63ed0/jahanzeb-ahsan-nvnoy_dkvxa-unsplash.webp',
      alt: 'Wohnmobilstellplatz Bremen',
      title: 'Wohnmobilstellplatz Bremen',
    },
    slug: 'zeltplatz',
    rest: 'bremen',
  },
  {
    title: 'Ostsee',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/2399x1396/0f264d1fd8/title-image-ostsee.webp',
      alt: 'Strand an der Ostsee.',
      title: 'Strand an der Ostsee.',
    },
    slug: 'zeltplatz',
    rest: 'ostsee',
  },
  {
    title: 'Cuxhaven',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/640x679/03106f6d9b/jw-slryeb8awfk-unsplash.webp',
      alt: 'Wohnmobilstellplatz Cuxhaven',
      title: 'Wohnmobilstellplatz Cuxhaven',
    },
    slug: 'zeltplatz',
    rest: 'cuxhaven',
  },
  {
    title: 'Allgäu',
    subtitle: 'Zeltplätze',
    image: {
      filename: 'https://a.storyblok.com/f/267180/5579x3720/9fd5e22030/allgau.jpg',
      alt: 'Wohnmobilstellplatz Cuxhaven',
      title: 'Wohnmobilstellplatz Cuxhaven',
    },
    slug: 'zeltplatz',
    rest: 'allgaeu',
  },
  // Add more destinations as needed
];

const StoryblokRegionsTentPreset = () => {
  const intl = useIntl();

  return (
    <Container
      maxWidth="xl"
      sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}
    >
      <Typography component="h2" sx={{ mb: 6 }} variant="h3">
        <FormattedMessage id="SectionRegions.tent.header" />
      </Typography>
      <Grid container justifyContent="center" spacing={4}>
        {destinations.map((destination, index) => {
          const link = createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: destination.slug, rest: destination.rest },
            {},
            intl.locale,
          );

          return (
            <Grid key={index} size={{ lg: 4, md: 6, xs: 12 }}>
              <RegionCard
                image={destination.image}
                link={link}
                subtitle={destination.subtitle}
                title={destination.title}
              />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default withBaseComponent(StoryblokRegionsTentPreset);
